"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimeline = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var UseLoadMore_1 = require("Analytics/Page/Components/UseLoadMore");
var AnalyticsEmptyState_1 = require("../EmptyState/AnalyticsEmptyState");
var styles = __importStar(require("./Timeline.css"));
var sortOptions = [
    {
        icon: react_1.default.createElement(icons_1.SortDescending, null),
        description: "Most recent",
        sortFn: function (arr) {
            return arr;
        },
    },
    {
        icon: react_1.default.createElement(icons_1.SortAscending, null),
        description: "Earliest",
        sortFn: function (arr) {
            return __spreadArray([], __read(arr), false).reverse();
        },
    },
];
var useTimeline = function (props) {
    var _a = __read((0, react_1.useState)(0), 2), sortOptionIndex = _a[0], setSortOptionIndex = _a[1];
    var sortOption = sortOptions[sortOptionIndex];
    var timelineComponent = react_1.default.createElement(Timeline, __assign({}, props, { sortOption: sortOption }));
    var hasTimelineData = props.timelineData && props.timelineData.length > 0;
    var timelineFilterButtons = (react_1.default.createElement(SortAndFilterButtons, { sortOptionIndex: sortOptionIndex, filtersButton: props.filtersButton, onClick: function () { return setSortOptionIndex((sortOptionIndex + 1) % sortOptions.length); }, disabled: !hasTimelineData }));
    return { timelineComponent: timelineComponent, timelineFilterButtons: timelineFilterButtons };
};
exports.useTimeline = useTimeline;
var Timeline = function (_a) {
    var timeZone = _a.timeZone, sortOption = _a.sortOption, timelineData = _a.timelineData, renderEventCard = _a.renderEventCard, getEventIcon = _a.getEventIcon;
    if (!timelineData) {
        return react_1.default.createElement(kaleidoscope_1.Spinner, { primary: true });
    }
    var sortedData = sortOption.sortFn(timelineData);
    return (react_1.default.createElement(LoadedTimeline, { timelineData: sortedData, timeZone: timeZone, renderEventCard: renderEventCard, getEventIcon: getEventIcon }));
};
var LoadedTimeline = function (_a) {
    var timelineData = _a.timelineData, timeZone = _a.timeZone, renderEventCard = _a.renderEventCard, getEventIcon = _a.getEventIcon;
    var _b = (0, UseLoadMore_1.useLoadMore)(timelineData, {
        initialItemCount: 5,
        increment: 10,
    }), itemsToShow = _b.itemsToShow, loadMoreButtons = _b.loadMoreButtons;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { align: "center" },
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.timeline }, timelineData.length === 0 ? (react_1.default.createElement(AnalyticsEmptyState_1.AnalyticsEmptyState, { title: "No events in this time range" })) : (timelineData.slice(0, itemsToShow).map(function (rowData, index) {
            return (react_1.default.createElement("div", { key: rowData.key, className: styles.timelineRow },
                react_1.default.createElement(TimeComponent, { timeStamp: rowData.timeStamp, timeZone: timeZone }),
                react_1.default.createElement("div", { className: styles.iconAndConnectorLines },
                    react_1.default.createElement(ConnectorLines, { isLast: index === timelineData.length - 1 }),
                    react_1.default.createElement(EventIcon, { icon: getEventIcon(rowData) })),
                react_1.default.createElement(kaleidoscope_1.Card, { className: styles.eventCard }, renderEventCard(rowData))));
        }))),
        loadMoreButtons));
};
var TimeComponent = function (_a) {
    var timeStamp = _a.timeStamp, timeZone = _a.timeZone;
    var formattedDate = new Intl.DateTimeFormat(undefined, {
        weekday: "short",
        day: "numeric",
        month: "short",
        year: "numeric",
        timeZone: timeZone,
    }).format(timeStamp);
    var formattedTime = new Intl.DateTimeFormat(undefined, {
        timeStyle: "short",
        hourCycle: "h12",
        timeZone: timeZone,
    }).format(timeStamp);
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.timeComponent, align: "end", paddingTop: "s" },
        react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", lineHeight: "compact" }, formattedDate),
        react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, formattedTime)));
};
var ConnectorLines = function (_a) {
    var isLast = _a.isLast;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles.horizontalConnectorLine }),
        !isLast && react_1.default.createElement("div", { className: styles.verticalConnectorLine })));
};
var SortAndFilterButtons = function (_a) {
    var sortOptionIndex = _a.sortOptionIndex, disabled = _a.disabled, filtersButton = _a.filtersButton, onClick = _a.onClick;
    var sortOption = sortOptions[sortOptionIndex];
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: { tablet: "xs" } },
        react_1.default.createElement(kaleidoscope_1.Button, { className: styles.sortButton, onClick: onClick, type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Small, disabled: disabled },
            sortOption.icon,
            sortOption.description),
        filtersButton));
};
var EventIcon = function (_a) {
    var icon = _a.icon;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.eventIconFrame, align: "center", justify: "center" }, icon));
};
